/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { SamlUiLogoInfo } from './SamlUiLogoInfo';
const SamlUiInfoParser = /* #__PURE__ */ parsers.object([
    ['name', codecString],
    ['description', codecString],
    ['logo', /* #__PURE__ */ parsers.maybeNull(SamlUiLogoInfo)],
]);
export class SamlUiInfo extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SamlUiInfoParser.decode(input).map(res => new SamlUiInfo(res));
    }
    static unsafeDecode(input) {
        return SamlUiInfo.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SamlUiInfoParser.encode(data);
    }
    static schema() {
        return SamlUiInfoParser.schema();
    }
}
